const IconData = [
    {
        id: 1,
        cover: require("../../Assets/Icons/icon1.png"),
        title:"Indoor All-Weather-Controlled Pool",
        altTag:"DLF The Crest Delhi"
    },
    {
        id: 2,
        cover: require("../../Assets/Icons/icon2.png"),
        title:"Luxe Spa And Salon",
        altTag:"DLF The Crest"
    },
    {
        id: 3,
        cover: require("../../Assets/Icons/icon3.png"),
        title:"Kids’ Pool Area",
        altTag:"DLF The Crest Delhi price"
    },
    {
        id: 4,
        cover: require("../../Assets/Icons/icon4.png"),
        title:"Gym",
        altTag:"DLF The Crest Delhi plans"
    },
    {
        id: 5,
        cover: require("../../Assets/Icons/icon5.png"),
        title:"Banquet Hall",
        altTag:"DLF The Crest Delhi Expressway"
    },
]

export default IconData